export function createStorageBoxUploadJob(files) {
  const list = [...files];
  const totalBytes = list.reduce((sum, f) => sum + (f.size || 0), 0);
  return {
    active: true,
    phase: 'preparing',
    fileCount: list.length,
    fileIndex: list.length ? 1 : 0,
    currentName: list[0]?.name || '',
    totalBytes,
    loadedBytes: 0,
    percent: 0,
  };
}

/** @param {{ loaded: number; total?: number; percent?: number }} evt */
export function mergeUploadProgressPercent(evt, encryptWeightPercent = 0) {
  const uploadShare = (100 - encryptWeightPercent) / 100;
  const raw =
    evt.percent != null ? evt.percent : evt.total ? (evt.loaded / evt.total) * 100 : 0;
  return Math.min(100, Math.round(encryptWeightPercent + raw * uploadShare));
}
